import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutPaymentConnector, CheckoutPaymentService } from '@spartacus/checkout/base/core';
import { CheckoutQueryFacade } from '@spartacus/checkout/base/root';
import {
  CommandService,
  EventService, OCC_USER_ID_ANONYMOUS, PaymentDetails, ProcessSelectors, QueryService,
  StateWithProcess,
  UserIdService
} from '@spartacus/core';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomCheckoutActions } from '../store/actions';
import { SET_PAYMENT_DETAILS_PROCESS_ID, StateWithCheckout } from '../store/custom-checkout-state';

@Injectable({
  providedIn: 'root',
})
export class CustomCheckoutPaymentService extends CheckoutPaymentService {
  constructor(
    protected activeCartFacade: ActiveCartFacade,
    protected userIdService: UserIdService,
    protected queryService: QueryService,
    protected commandService: CommandService,
    protected eventService: EventService,
    protected checkoutPaymentConnector: CheckoutPaymentConnector,
    protected checkoutQueryFacade: CheckoutQueryFacade,
    protected checkoutStore: Store<StateWithCheckout | StateWithProcess<void>>
  ) {
    super(activeCartFacade, userIdService, queryService, commandService, eventService, checkoutPaymentConnector, checkoutQueryFacade);
  }

  customCreatePaymentDetails(paymentDetails: PaymentDetails): void {
    if (this.actionAllowed()) {
      let userId;
      this.userIdService
        .getUserId()
        .subscribe((occUserId) => (userId = occUserId))
        .unsubscribe();

      let cartId;
      this.activeCartFacade
        .getActiveCartId()
        .subscribe((activeCartId) => (cartId = activeCartId))
        .unsubscribe();

      if (userId && cartId) {
        this.checkoutStore.dispatch(
          new CustomCheckoutActions.CreatePaymentDetails({
            userId,
            cartId,
            paymentDetails
          })
        );
      }
    }
  }

  protected actionAllowed(): boolean {
    let userId;
    this.userIdService
      .getUserId()
      .subscribe((occUserId) => (userId = occUserId))
      .unsubscribe();

    let isGuestCart;
    this.activeCartFacade.isGuestCart().subscribe(
      (data) => {
        isGuestCart = data;
      }
    )

    return (
      (userId && userId !== OCC_USER_ID_ANONYMOUS) ||
      isGuestCart
    );
  }

  getSetPaymentDetailsResultProcess(): Observable<StateUtils.LoaderState<void>> {
    return this.checkoutStore.pipe(
      select(ProcessSelectors.getProcessStateFactory(SET_PAYMENT_DETAILS_PROCESS_ID))
    );
  }
}
